// extracted by mini-css-extract-plugin
module.exports = {"discountTag":"DiscountTagRebrand_discountTag__2hV1d"};